module.exports = __webpack_public_path__ + "img/hkliving_stream.afd8ef63.jpeg";